import { useAppConstantsContext } from '@/context/AppConstants';
import { Grid, Text } from '@/theme/index';

export interface ReferralsHeaderProps {
  inviteCount: number;
}

export function ReferralsHeader({ inviteCount }: ReferralsHeaderProps) {
  const {
    data: { brandName },
    images: { imgReferralsIcon },
  } = useAppConstantsContext();

  return (
    <Grid container direction="column" alignItems="center" mb={3}>
      <Grid item>
        <img src={imgReferralsIcon} alt="Referrals" />
      </Grid>
      <Grid item>
        <Text variant="h1" align="center">
          Refer your friends and family
        </Text>
      </Grid>
      <Grid item>
        {inviteCount < 3 ? (
          <Text variant="body1" align="center">
            You have <b>3 invites</b> to send to your friends and family so they
            can <b>{` try ${brandName} for $1!`}</b>
          </Text>
        ) : (
          <Text variant="body1" align="center">
            {`You have no invites left to send. Thanks for sharing ${brandName}`}
          </Text>
        )}
      </Grid>
    </Grid>
  );
}
